<template>
  <div class="app-center-container">
    <div class="container-top">
      <div class="main-title">AI应用中心</div>
    </div>
    <div class="tab-list">
      <div class="tab-item" @click="handleTabClick(index)" :class="{ 'active': index==activeIndex }" v-for="(item,index) in appList">
        <div class="icon"></div>
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
    <div class="main-content">
      <div class="left-content">
        <div class="left-item" v-if="appDetail">
          <div class="title">{{ appDetail.name }}</div>
          <div class="text">{{ appDetail.description }}</div>
          <div class="right-btn" @click="handleMore(appDetail)">
            <span>查看更多</span>
            <div class="icon">
              <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/494869a003dc4f3a94b72ff970738cd8.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="right-content" v-if="appDetail">
        <!-- <video preload :src="appDetail.video_url || 'https://alivideo.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/05a32c9084904552bd7322f3212f3011.mp4'"></video> -->
        <img src="	https://image.zhihuishu.com/zhs/b2cm/base1/202507/8904464096244a3ba68969f80e86476f.png"/>
        <div class="toggle-btn">
          <div class="btn pre-btn" @click="prevPage"></div>
          <div class="line"></div>
          <div class="btn next-btn" @click="nextPage"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { handleLogin } from '@/plugins/utils'

const props = defineProps({
  userRole: {
    type: Number || String,
    default: 0,
  },
})

const $http = inject('$http')

const tabList = ['3D数字人', 'AI大模型', '论文相似度检测', '虚拟数字教师', '慕课出海', ' AIGC检测'];

const activeIndex = ref(0);

const appList = ref([]);

const courseInterval = ref(null);

const timer = 10000

const appDetail = computed(() => {
  return appList.value.length >0 ? appList.value[activeIndex.value] : null;
});

const getAppList = async () => {
  const data = await $http.getAiAppList({ type: 1, role: props.userRole, });
  appList.value = data;
};

const startInterval = ()=> {
  clearInterval(courseInterval.value)
  courseInterval.value = setInterval(() => {
    if(activeIndex.value == appList.value.length-1) {
      activeIndex.value = 0
    } else {
      activeIndex.value++
    }
  }, timer) 
}

const prevPage = ()=> {
  //startInterval()
  if(activeIndex.value > 0) {
    activeIndex.value--
  } else {
    activeIndex.value=appList.value.length-1
  }
}

const nextPage = ()=> {
  // startInterval()
  if(activeIndex.value < appList.value.length - 1) {
    activeIndex.value++
  } else {
    activeIndex.value=0
  }
}

const handleMore = (item) => {
  if(props.userRole==0) {
    // 跳转至登录页面
    handleLogin()
    return
  }
  if(item.has_auth==0) {
    ElMessage.warning('暂无权限')
    return
  }
  window.open(item.jump_url)
}

onMounted(() => {
  getAppList();
});

const handleTabClick = (index) => {
  activeIndex.value = index;
};  

</script>

<style lang="scss" scoped>
.app-center-container {
  padding-top: 40px;
  height: 760px;
  width: 1280px; 
  position: relative;
  .container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    .main-title {
      color: #1C212A;
      font-family: "Alibaba PuHuiTi";
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
  }
  .tab-list {
    display: flex;
    justify-content: space-around;
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 3px;
      background-color: #fff;
      position: absolute;
      top: 28px;
      left: 0;
      z-index: 0;
    }
    .tab-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      .icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 1);
        background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/cb3fff09e0ea4282af89ed5cf1f724dd.png');
        background-size: 25px 25px;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
      }
      .title {
        color: #000;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        margin-top: 12px;
      }
      &.active {
        .icon {
          background-color: #194189;
          background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/920a0c9f227c4605a33c00a2f8bb34e5.png');
        }
        .title {
          font-weight: 600;
        }
      }
    }
  }
  .main-content {
    margin-top: 60px;
    display: flex;
    .left-content {
      flex: 1;
      .left-item {
        .title {
          color: #000;
          font-family: "PingFang SC";
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          line-height: 48px; /* 171.429% */
        }
        .text {
          color: #000;
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 28px; /* 200% */
          width: 484px;
          text-indent: 28px;
          margin-top: 20px;
          height: 84px;
        }
        .right-btn {
          width: 176px;
          height: 50px;
          background-color: #194189;
          border-radius: 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 128px;
          cursor: pointer;
          .icon {
            width: 40px;
            height: 40px;
            margin-left: 8px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          &:hover {
            .icon {
              img {
                animation: btnFadeIn 0.2s ease-in-out;
              }
            }
          }
          span {
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            color: #fff;
          }
          @keyframes btnFadeIn {
            0% {
              opacity: 0;
              width: 0;
              height: 100%;
            }
            100% {
              opacity: 1;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .right-content {
      flex: 1;
      display: flex;
      align-items: center;
      video, img {
        width: 613px;
        height: 328px;
        border-radius: 6px;
        object-fit: fill;
      }
      .toggle-btn {
        width: 35px;
        height: 93px;
        border-radius: 35px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 24px;
        .btn {
          width: 16px;
          height: 16px;
          background-size: 100% 100%;
          cursor: pointer;
          &.pre-btn {
            background-image: url("https://image.zhihuishu.com/zhs/b2cm/base1/202507/aa94ab4dfdae4bacb0f7d9bc78d12b58.png");
          }
          &.next-btn {
            background-image: url("https://image.zhihuishu.com/zhs/b2cm/base1/202507/cffe5fd750e949a59b6609816dca22be.png");
          }
        }
        .line {
          width: 15px;
          height: 1px;
          background-color: #E6E8E9;
          margin: 12px 0;
        }
      }
    }
  }
}
</style>